import React from 'react';
import {observer} from 'mobx-react';
import {Modal, ModalButtons} from 'components/modals';
import {FormattedMessage} from 'react-intl';
import {t} from 'shared/core';

const ApplyCoverageModal = observer(({uiState}) => {
  const {applyCoverageModalOpen, currentEligibilityRecord} = uiState;

  return (
    <Modal isOpen={applyCoverageModalOpen} 
      onHide={() => uiState.closeModals()} size='md'
      title='components.additional_coverage.Applying for additional coverage'>
      <div>
        <FormattedMessage id='components.additional_coverage.INSTRUCTION_ONE' 
          values={{
            insurabilityText: <b>{t('components.additional_coverage.Evidence of Insurability')}</b>,
            insuranceCarrier: currentEligibilityRecord.companyInsuranceCarrier
          }}/>
      </div>
      <div className='my2'>
        <FormattedMessage id='components.additional_coverage.INSTRUCTION_TWO'/>
      </div>
      <ModalButtons saveCaption='components.additional_coverage.Download Form'
        onSave={() => uiState.openDocument()}
        onCancel={() => uiState.closeModals()}/>
    </Modal>
  );
});

export default ApplyCoverageModal;
